<template>
  <a
    :href="`/${PROFILE_PATH}/${user.username}${articleCount > 0 ? '/' + FAVORITE_PATH : ''}`"
    class="flex p-2 bg-[#E9EAED] items-center rounded-lg h-8"
  >
    <OIcon icon="article/saved-button" svg-class="w-4 h-4 mr-1" :alt="$t('user-popover.reading-list')" />
    <p class="text-xxs font-medium text-primary-100">Okuma Listem</p>
  </a>
</template>
<script>
import { defineComponent, computed } from '@nuxtjs/composition-api';
import OIcon from '~/modules/common/components/ui/OIcon/OIcon.vue';
import { useAuth } from '~/modules/auth/state/useAuth';
import { PROFILE_PATH, FAVORITE_PATH } from '~/constants/config';

export default defineComponent({
  components: {
    OIcon,
  },
  setup() {
    const { user } = useAuth();
    const articleCount = computed(() => user.value.stats?.articles);

    return { PROFILE_PATH, FAVORITE_PATH, user, articleCount };
  },
});
</script>
